import React from "react";
import Menu from "@mui/material/Menu";
import { Col, Table } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import NoImage from "../images/Logo Png-01.png";
import { MdDelete } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import { MdRemoveShoppingCart } from "react-icons/md";

const CartBody = ({ anchorEl, open, handleClose, getdata, dlt, price }) => {
  return (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
    >
      {getdata.length ? (
        <div className="cart_body_details">
          <Table>
            <thead>
              <tr>
                <th>Photo</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {getdata.map((e) => {
                const cleanSlug = e.slug ? e.slug.replace(/-/g, " ") : "N/A";

                // Image logic
                let displayImage = NoImage;

                // Check for images
                if (e.imagestwo) {
                  displayImage = e.imagestwo
                    .replace(/["\\[\]]/g, "")
                    .replace(/\/storage\/media/, "/storage/app/media");
                } else if (e.images && e.images.length > 0) {
                  displayImage = e.images[0].image_url || NoImage;
                }

                return (
                  <tr key={e.id}>
                    <td>
                      <NavLink to={`/single-product/${e.id}`}>
                        <div className="product_images">
                          <img
                            src={displayImage}
                            className="cart_body_details_img"
                            alt="Product img"
                          />
                        </div>
                      </NavLink>
                    </td>
                    <td>
                      <p>{cleanSlug}</p>
                      <p>Price : ${e.price}</p>
                      <p>Quantity : {e.qnty}</p>
                    </td>
                    <td
                      className="cart_body_details_dlt"
                      onClick={() => dlt(e.id)}
                    >
                      <MdDelete />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
          <div className="row">
            <Col xs="4" sm="4" md="4" lg="5">
              <p>Total: ${price}</p>
            </Col>
            <Col xs="3" sm="4" md="4" lg="3">
              <button className="custom_btn_card">
                <Link to="/cart">Cart</Link>
              </button>
            </Col>
            <Col xs="5" sm="4" md="4" lg="4">
              <button className="custom_btn_card">
                <Link to="/checkOut">Check Out</Link>
              </button>
            </Col>
          </div>
        </div>
      ) : (
        <div className="cart_body">
          <i
            onClick={handleClose}
            style={{
              position: "absolute",
              top: 2,
              right: 20,
              fontSize: 23,
              cursor: "pointer",
            }}
          >
            <IoClose />
          </i>
          <p>Your cart is empty</p>
          <div className="emptycart_img">
            <MdRemoveShoppingCart />
          </div>
        </div>
      )}
    </Menu>
  );
};

export default CartBody;
